import React, { useState, useEffect } from "react";
import Layout from "../layout/Layout";

import Confirm from "../assets/img/confirm.png";
import { Link, useNavigate, useParams } from "react-router-dom";

import axiosInstance from "../../apiInstances/axiosInstance";
import axiosInstanceAuthFormData from "../../apiInstances/axiosInstanceAuthFormData";
import { toast } from "react-toastify";
import RootLayout from "../authentication/root-layout";
import useEncryption from "../useEncryption/useEncryption";

const CompanyDetails = () => {
  const { decryptData } = useEncryption();
  const [showForm, setShowForm] = useState(false);
  let { id } = useParams();
  const toggleForm = () => {
    setShowForm(true);
  };

  const navigate = useNavigate();

  const [companyData, setCompanyData] = useState({
    companyname: "",
    address: "",
    contact: "",
    email: "",
    entitytype: "",
    strength: "",
    logo: "",
  });

  const onChangeInput = (e) => {
    // const { name, value } = e.target;
    const value = e.target.value;
    const name = e.target.name;

    setCompanyData({
      ...companyData,
      [name]: value,
    });
  };

  const onChangeImages = (e) => {
    const { name } = e.target;
    setCompanyData({
      ...companyData,
      [name]: e.target.files[0],
    });
  };

  const AddNewCompany = async () => {
    try {
      const formData = new FormData();

      formData.append("companyname", companyData?.companyname);
      formData.append("address", companyData?.address);
      formData.append("contact", companyData?.contact);
      formData.append("email", companyData?.email);
      formData.append("entitytype", companyData?.entitytype);
      formData.append("strength", companyData?.strength);
      formData.append("logo", companyData?.logo);

      axiosInstanceAuthFormData
        .post(`add_company/${id}`, formData)
        .then((res) => {
          console.log("res=================", res);
          const myData = decryptData(res?.data?.data);
          console.log("__###__#####", res);
          if (myData?.status) {
            navigate(`/`);
            toast.success(res?.data?.msg);
          } else {
            toast.error(res?.data?.msg);
          }
        })
        .catch((err) => {
          console.log("------>> Error", err);
        });
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (showForm) {
      const timer = setTimeout(() => {
        setShowForm(false);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [showForm]);

  // const data = () => {
  //   localStorage.setItem("Deatils", "deatils");
  //   navigate("/signin");
  //   setShowForm(false);
  // };
  // const Token = localStorage.getItem("token");

  return (
    <RootLayout>
      {/* {Token === undefined ? null : ( */}
      <div className=" top-0 left-[0%]  w-full h-full   grid place-items-center place-content-center ">
        <div className="h-auto  filter-screen-model outline-none bg-white my-20 rounded-2xl shadow-2xl mx-5 ">
          <div>
            <div>
              <div className="flex justify-center items-center">
                <div className="absolute">
                  <div class="bg-[#22345C] text-lg text-white font-sans underline font-bold py-2 px-4 rounded-[10px]">
                    Company Details
                  </div>
                </div>
              </div>
              <div className="p-5">
                <div class="grid grid-cols-1 gap-6 mt-4  mx-96">
                  <div className="">
                    <label class="text-[#000000]  font-sans font-bold text-lg">
                      Company's name :
                    </label>
                    <input
                      type="text"
                      class="block w-96 px-2 py-2 mt-2 font-sans text-[#000000] bg-[#F0F0F0]   rounded-md outline-none"
                      name="companyname"
                      value={companyData?.companyname}
                      onChange={onChangeInput}
                    />
                  </div>

                  <div>
                    <label class="text-[#000000]  font-sans font-bold text-lg">
                      Registered address :
                    </label>
                    <input
                      type="text"
                      class="block w-96 px-2 py-2 mt-2 font-sans text-[#000000] bg-[#F0F0F0]   rounded-md outline-none"
                      name="address"
                      value={companyData?.address}
                      onChange={onChangeInput}
                    />
                  </div>

                  <div>
                    <label class="text-[#000000]  font-sans font-bold text-lg">
                      Contact details :
                    </label>
                    <input
                      type="text"
                      class="block w-96 px-2 py-2 mt-2 font-sans text-[#000000] bg-[#F0F0F0]   rounded-md outline-none"
                      name="contact"
                      value={companyData?.contact}
                      onChange={onChangeInput}
                    />
                  </div>

                  <div>
                    <label class="text-[#000000]  font-sans font-bold text-lg">
                      Email address :
                    </label>
                    <input
                      type="email"
                      class="block w-96 px-2 py-2 font-sans mt-2 text-[#000000] bg-[#F0F0F0]   rounded-md outline-none"
                      name="email"
                      value={companyData?.email}
                      onChange={onChangeInput}
                    />
                  </div>

                  <div className="space-y-2">
                    <label
                      class="text-[#000000]  font-sans font-bold text-lg"
                      for="username"
                    >
                      Entity type :
                    </label>
                    <select
                      class="bg-[#F0F0F0] text-[#000000] font-sans  rounded-md   block w-96 p-2.5 focus:outline-none"
                      name="entitytype"
                      value={companyData?.entitytype}
                      onChange={onChangeInput}
                    >
                      <option selected disabled>
                        Choose a any
                      </option>
                      <option>Corporation</option>
                      <option>Non-profit</option>
                      <option>Partnership</option>
                      <option>Government</option>
                      <option>Other</option>
                    </select>
                  </div>

                  <div className="space-y-2">
                    <label
                      class="text-[#000000]  font-sans font-bold text-lg"
                      for="username"
                    >
                      Company’s strength :
                    </label>
                    <select
                      class="bg-[#F0F0F0] text-[#000000] font-sans  rounded-md   block w-96 p-2.5 focus:outline-none"
                      name="strength"
                      value={companyData?.strength}
                      onChange={onChangeInput}
                    >
                      <option selected disabled>
                        Choose a any
                      </option>

                      <option>0-10</option>
                      <option>11-50</option>
                      <option>51-200</option>
                      <option>201-1000</option>
                      <option>More than 1000</option>
                    </select>
                  </div>

                  <div>
                    <label
                      class="text-[#000000]  font-sans font-bold text-lg"
                      for="username"
                    >
                      Upload company’s logo :
                    </label>
                    <input
                      type="file"
                      class="block w-96 px- py- file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-md file:font-semibold file:bg-[#22345C] file:text-white font-sans mt-2 text-[#000000] bg-[#F0F0F0] rounded-md outline-none"
                      name="logo"
                      onChange={onChangeImages}
                    />
                  </div>
                </div>
              </div>

              <div class="flex justify-end mx- mt-7 gap-4 mb-5 mx-10">
                <div className="">
                  <button
                    onClick={() => {
                      AddNewCompany();
                      toggleForm();
                    }}
                    class="bg-[#5DC90A]  px-6 py-2 leading-5  text-white font-bold  rounded-[6px]"
                  >
                    Save
                  </button>
                </div>
                <div>
                  <button class="bg-[#FF270E] px-6 py-2 leading-5 text-white font-bold rounded-[6px]">
                    Cancel
                  </button>
                </div>
              </div>
            </div>
            {showForm ? (
              <>
                <div className="fixed top-0 left-[0%] z-[9999999999999] w-full h-full  backdrop-brightness-50 grid place-items-center place-content-center ">
                  <div className="h-auto  filter-screen-model outline-none  rounded-2xl shadow-2xl mx-5 ">
                    {/* <div className="absolute inset-0 bg-gray-800 opacity-75" /> */}
                    <div className="relative">
                      <div className="bg-[#17C09E] rounded-t-[10px] shadow-lg z-10 h-4"></div>
                      <div className="bg-white p-5 rounded-b-[23px] shadow-lg z-10">
                        <div className=" border-[1.5px] border-[#000000] m-2 rounded-[10px] ">
                          <div className="p-5">
                            <div className="flex justify-center">
                              <img src={Confirm} alt="" />
                            </div>
                            <div>
                              <p className="text-[#000000] mt-5 mx-24 font-sans font-bold text-2xl">
                                Thank you For Submitting Your Company Details
                              </p>
                            </div>
                            <div className="flex justify-center">
                              <Link to="/">
                                <div
                                  className="mt-8 bg-[#22345C] text-white font-semibold py-1 justify-center px-8 rounded-[18px] focus:outline-none  "
                                  // onClick={closePopup}
                                >
                                  Okay
                                </div>
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : null}
          </div>
        </div>
      </div>
      {/* )}  */}
    </RootLayout>
  );
};

export default CompanyDetails;
